import React from 'react'
import { UserManagementAdminStyled } from './styled'
import {
  Button,
  Modal,
  Image,
  InputSearch,
  Paginate,
  Section,
  SelectBox,
  Table,
  Spinner,
  Input,
} from '../../components'
import { ICONS } from '../../themes'
import { ROUTE_PATH, STRING } from '../../helpers'
import { store } from 'store'
import { usermanageController } from '../../apiService'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'
import { isEmpty } from 'lodash'
import {
  dateMonDayYearTime,
  formatNumberWithComma,
} from '../../helpers/functions/format'

class UserManagementAdmin extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      options: [
        { value: 'All', label: 'All', id: 1 },
        { value: 'Admin', label: 'Admin', id: 1 },
      ],
      isSortBy: [
        { name: 'id', value: undefined },
        { name: 'name', value: undefined },
      ],
      modals: [
        // { name: 'history', isOpen: false },
        { name: 'delete', isOpen: false },
      ],
      isLoading: false,
      adminDetail: {
        adminId: null,
        adminName: '',
        typemodal: '',
      },
      selectStatus: 1,
      activePage: 1,
      searchPage: 1,
      searchKeyWord: '',
      orderBy: null,
      sortFiedName: null,
      responseGetAdmin: {
        limit: null,
        next_page: null,
        offset: null,
        page: null,
        prev_page: null,
        records: [],
        total_page: null,
        total_record: null,
      },
      listAdminUsermanagement: [],
    }
  }

  componentDidMount() {
    this.fetchAdminList()
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.user) {
      this.fetchAdminList()
    }
  }

  setLoading = (status = false) => {
    this.setState({ isLoading: status })
  }

  fetchAdminList = async () => {
    try {
      const { user } = store.getState()
      this.setLoading(true)
      if (user && user.role) {
        const params = {
          role_id: [this.state.selectStatus],
          keyword: this.state.searchKeyWord,
          page: this.state.activePage,
          sort_name: this.state.sortFiedName,
          sort_by: this.state.orderBy,
        }
        const res = await usermanageController().getListAdmin(params)
        this.setState({
          listAdminUsermanagement: res.result.records || [],
          responseGetAdmin: res.result || {},
        })
        this.setLoading(false)
      }
    } catch (error) {
      throw new Error(error)
    }
  }

  onPageChange = pageNumber => {
    this.setState(
      prevState => {
        return { ...prevState, activePage: pageNumber }
      },
      () => {
        this.fetchAdminList()
      }
    )
  }

  onInputChange = event => {
    this.setState({ searchKeyWord: event.target.value })
  }

  findSortBy = evt => {
    let sortBy = ''
    this.state.isSortBy.find(column => {
      if (column.name === evt && column.value == undefined) {
        sortBy = 'asc'
      } else if (column.name === evt && column.value == 'asc') {
        sortBy = 'desc'
      } else if (column.name === evt && column.value == 'desc') {
        sortBy = 'asc'
      }
      return sortBy
    })
    return sortBy
  }

  toggleSort = evt => {
    const orderBy = this.findSortBy(evt)
    const sortFiedName = evt
    this.setState(
      prevState => {
        const isSortBy = prevState.isSortBy.map(column => ({
          ...column,
          value:
            column.name === evt
              ? column.value !== undefined
                ? column.value === 'asc'
                  ? 'desc'
                  : 'asc'
                : 'asc'
              : undefined,
        }))
        return {
          ...prevState,
          isSortBy,
          orderBy,
          sortFiedName,
        }
      },
      () => {
        this.fetchAdminList()
      }
    )
  }

  filterSortByValue = evt => {
    return this.state.isSortBy
      .filter(columns => columns.name === evt)
      .map(column => column.value)[0]
  }

  searchUsermanagement = () => {
    try {
      this.fetchAdminList()
    } catch (error) {
      throw new Error(error)
    }
  }

  onEnter = event => {
    if (event.key === 'Enter' && event.keyCode === 13) {
      this.fetchAdminList()
    }
  }

  onSelectStatus = StatusId => {
    this.setState({ selectStatus: StatusId }, () => {
      this.fetchAdminList()
    })
  }

  toggleModal = (evt, adminId, adminName) => {
    this.setState(prevState => ({
      ...prevState,
      modals: prevState.modals.map(modal => ({
        ...modal,
        isOpen: modal.name === evt ? !modal.isOpen : false,
      })),
    }))
    if (adminId && adminName) {
      this.setState({
        adminDetail: {
          adminId,
          adminName,
          typemodal: evt,
        },
      })
    }
  }

  deleteAdminById = async () => {
    const { typemodal, adminId, adminName } = this.state.adminDetail
    try {
      const res = await usermanageController().deleteAdminById(adminId)
      if (res.status === 'DeleteSuccess') {
        this.fetchAdminList()
        toast.success('User was Deleted')
      }
      this.toggleModal(typemodal, adminId, adminName)
    } catch (error) {
      this.toggleModal(typemodal, adminId, adminName)
      toast.error('Can not delete User')
      throw new Error(error)
    }
  }

  checkTypeModal = async () => {
    const { typemodal, adminId } = this.state.adminDetail
    if (typemodal && adminId) {
      if (typemodal === 'delete') {
        this.deleteAdminById(adminId)
      }
    }
  }

  renderListAdmin = (listAdminData = []) => {
    return listAdminData.map(adminData => this.renderDetail(adminData))
  }

  renderDetail = (
    adminData = {
      id: null,
      code: '',
      full_name: '',
      email: '',
      phone: '',
      role_id: null,
      create_date: null,
      update_date: null,
    }
  ) => {
    return (
      <Table.TR key={adminData.id}>
        <Table.TD className="id">
          {adminData.code || String(adminData.id).padStart(3, '0')}
        </Table.TD>
        <Table.TD className="name">{adminData.full_name}</Table.TD>
        <Table.TD className="email" title={adminData.email}>
          {adminData.email}
        </Table.TD>
        <Table.TD className="phone">{adminData.phone}</Table.TD>
        <Table.TD className="role">
          {adminData.role_id === 1 && 'Admin'}
        </Table.TD>
        <Table.TD className="created-date">
          {dateMonDayYearTime(adminData.update_date)}
        </Table.TD>
        <Table.TD className="actions">
          <Section>
            <Button
              className="link"
              onClick={() => {
                this.props.history.push({
                  pathname:
                    ROUTE_PATH.USER_EDIT_FORM_ADMIN.PATH + `:${adminData.id}`,
                })
              }}
            >
              <Image
                className="edit-icon"
                src={ICONS['icon-edit.svg']}
                alt="edit"
              />
            </Button>

            <Button
              className="link"
              onClick={() =>
                this.toggleModal('delete', adminData.id, adminData.full_name)
              }
            >
              <Image
                className="delete-icon"
                src={ICONS['icon-trash.svg']}
                alt="delete"
              />
            </Button>
          </Section>
        </Table.TD>
      </Table.TR>
    )
  }
  render() {
    const {
      options,
      modals,
      listAdminUsermanagement,
      responseGetAdmin,
    } = this.state
    return (
      <React.Fragment>
        <UserManagementAdminStyled>
          {/* PAGE TITLE
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Section className="page-topbar">
            <Section className="page-header">
              <Section className="page-icon">
                <Image
                  id="page_icon_user_management"
                  src={ICONS['icon-user-white.svg']}
                  alt="page icon"
                />
              </Section>

              <Section className="title-and-breadcrumb">
                <Section id="page_title_user_management" className="title">
                  {STRING.USER_MANAGEMENT}
                </Section>

                <Section
                  id="page_breadcrumb_user_management"
                  className="breadcrumbs"
                >
                  <Button
                    className="breadcrumb"
                    onClick={() => {
                      this.props.history.push(ROUTE_PATH.HOME.LINK)
                    }}
                  >
                    <span>{STRING.HOME}</span>
                  </Button>

                  <Button className="breadcrumb current">
                    <span>{STRING.USER_MANAGEMENT}</span>
                  </Button>
                </Section>
              </Section>
            </Section>

            <Section className="page-button">
              {/* <Button
                className="page-button"
                onClick={() => {
                  this.props.history.push(
                    ROUTE_PATH.USER_DETAIL_FORM_ADMIN.LINK
                  )
                }}
              >
                <Image src={ICONS['icon-add-circular.svg']} alt="add icon" />
                Create User
              </Button> */}
              <Button
                className="page-button"
                onClick={() => {
                  this.props.history.push(
                    ROUTE_PATH.USER_DETAIL_FORM_ADMIN.LINK
                  )
                }}
              >
                {/* <Image src={ICONS['icon-add-circular.svg']} alt="add icon" /> */}
                Create User
              </Button>
            </Section>
          </Section>

          {/* PAGE CONTENT
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Section className="main-content">
            <Section className="content-body">
              <Section className="table-filter">
                <InputSearch
                  onClickSearchIcon={() => this.searchUsermanagement()}
                  id="filter_search_input"
                  placeholder="ID, Name"
                  onChange={this.onInputChange}
                  value={this.state.searchKeyWord}
                  onKeyDown={this.onEnter}
                />

                <SelectBox
                  id="active_status_filter"
                  className="table-filter all-status"
                  options={options}
                  placeholder="ALL"
                  isSearchable={false}
                  isClearable={false}
                  onChange={event => {
                    this.onSelectStatus(event.id)
                  }}
                />
              </Section>

              <Section className="table-wrapper">
                <Table className="user split-row-color">
                  {/* Header Row */}
                  <Table.THEAD>
                    <Table.TR className="header">
                      <Table.TH
                        className="id"
                        id="id_header"
                        isSortable={true}
                        sortBy={this.filterSortByValue('id')}
                        onClick={() => this.toggleSort('id')}
                      >
                        ID
                      </Table.TH>

                      <Table.TH
                        className="name"
                        id="name_header"
                        isSortable={true}
                        sortBy={this.filterSortByValue('name')}
                        onClick={() => this.toggleSort('name')}
                      >
                        NAME
                      </Table.TH>

                      <Table.TH className="email" id="email_header">
                        EMAIL
                      </Table.TH>

                      <Table.TH className="phone" id="phone_header">
                        PHONE
                      </Table.TH>

                      <Table.TH className="role" id="role_header">
                        ROLE
                      </Table.TH>

                      <Table.TH
                        className="created-date"
                        id="created_date_header"
                      >
                        UPDATE DATE
                      </Table.TH>

                      <Table.TH className="actions" id="actions_header">
                        ACTIONS
                      </Table.TH>
                    </Table.TR>
                  </Table.THEAD>

                  {/* Content Row */}
                  <Table.TBODY>
                    {this.state.isLoading ? (
                      <Spinner />
                    ) : (
                      this.renderListAdmin(listAdminUsermanagement)
                    )}
                  </Table.TBODY>
                  {isEmpty(listAdminUsermanagement) && (
                    <Section className="no-result-found">
                      <Image
                        src={ICONS['icon-ssr.png']}
                        className="no-result"
                      />
                      <p>No result found</p>
                    </Section>
                  )}
                </Table>
              </Section>
            </Section>

            <Section className="content-footer">
              <Section className="showing-item">
                Showing{' '}
                {(listAdminUsermanagement || []).length === 0
                  ? '0'
                  : formatNumberWithComma(
                      Math.min(
                        (responseGetAdmin.page - 1) * responseGetAdmin.limit + 1
                      )
                    )}{' '}
                to{' '}
                {formatNumberWithComma(
                  Math.min(
                    responseGetAdmin.total_record,
                    responseGetAdmin.limit * responseGetAdmin.page
                  )
                )}{' '}
                of {formatNumberWithComma(responseGetAdmin.total_record)}{' '}
                entries
              </Section>

              <Section className="paginate-wrapper">
                <Paginate
                  activePage={this.state.activePage}
                  itemsCountPerPage={this.state.responseGetAdmin.limit}
                  totalItemsCount={
                    this.state.responseGetAdmin.total_record || 0
                  }
                  // pageRangeDisplayed={this.state.responseGetAdmin.total_page}
                  onChange={pageNumber => this.onPageChange(pageNumber)}
                />

                <Section className="moveto-wrapper">
                  <Input
                    className="paginate-moveto"
                    label="Page"
                    defaultValue="1"
                    isHorizontal
                    maxLength="4"
                    value={this.state.searchPag}
                    onChange={e =>
                      this.setState({
                        searchPage: parseInt(e.target.value),
                      })
                    }
                  />

                  <Button
                    onClick={() => this.onPageChange(this.state.searchPage)}
                  >
                    go
                  </Button>
                </Section>
              </Section>
            </Section>
          </Section>
        </UserManagementAdminStyled>

        <Modal
          id="delete_id"
          className="theme-blue"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'delete'
              })
              .map(obj => obj.isOpen)[0]
          }
          modalWidth="575px"
        >
          <Modal.Header>Delete</Modal.Header>

          <Modal.Body>
            <p className="default text-center">
              Are you sure to delete? <br />
              {this.state.adminDetail.adminName}
            </p>
          </Modal.Body>

          <Modal.Footer>
            <Button
              id="close_modal_history_id"
              className="theme-border-gray"
              onClick={() => this.toggleModal()}
            >
              Cancel
            </Button>

            <Button
              id="close_modal_history_id"
              className="theme-green"
              onClick={() => this.checkTypeModal()}
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    )
  }
}
const mapStateToProps = state => {
  return {
    user: state.user,
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}
export const UserManagementAdminContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserManagementAdmin)
